module.exports = __webpack_public_path__ + "img/home.f5bf4bf9.svg";